import admin from './admin/'
import requests from './requests/'
import base from './base'
import patient from './patient'
import staff from './staff'
import exportRequests from './export'

export default {
    admin,
    requests,
    base,
    patient,
    staff,
    export: exportRequests
}
